import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import '../Css/Signin.css';

const Signin = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [captchaValue, setCaptchaValue] = useState(null);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setErrorMessage('');

        if (!captchaValue) {
            setErrorMessage('Please complete the CAPTCHA');
            setLoading(false);
            return;
        }

        try {
            const response = await fetch(`${apiUrl}/api/signin`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password, captchaValue }),
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();
            localStorage.setItem('token', data.token);
            localStorage.setItem('role', data.role);
            localStorage.setItem('username', data.username);

            onLogin({ role: data.role });

            navigate('/invoices-homepage');
        } catch (error) {
            console.error('Error during sign in:', error);
            setErrorMessage('Invalid username or password or CAPTCHA failed.');
        } finally {
            setLoading(false);
        }
    };

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value);
    };

    return (
        <div className="signin__container">
            <div className="signin__left">
                <h1>BIENVENUE</h1>
                <p>Softera.tn, La Solution Pour Faciliter Vos Facturations</p>
                <p>Une Plateforme Innovante Conçue Pour Simplifier les Processus de Réservation et de Facturation.</p>
            </div>
            <div className="signin__right">
                <form className="signin__form" onSubmit={handleSubmit}>
                    <h2>Sign In</h2>
                    {errorMessage && <p className="error-message">{errorMessage}</p>}
                    <input
                        className="signin__input"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        placeholder="Username"
                        required
                    />
                    <input
                        className="signin__input"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password"
                        required
                    />
                    <ReCAPTCHA
                        sitekey="6Le6orUqAAAAAHaRf68M8pbbutdJuNIPZvJoi2uI"
                        onChange={handleCaptchaChange}
                    />
                    {/*
                    <div className="signin__options">
                        <label>
                            <input type="checkbox" /> Remember me
                        </label>
                        <a href="/forgot-password">Forgot Password?</a>
                    </div>*/}
                    <button className="signin__button" type="submit" disabled={loading}>
                        {loading ? 'Signing In...' : 'Sign In'}
                    </button>
                    {/*
                    <div className="signin__divider">or</div>
                    <button className="signin__social-button">Sign in with other</button>
                    <p className="signin__signup">
                        Don't have an account? <a href="/signup">Sign Up</a>
                    </p>*/}
                </form>
            </div>
        </div>
    );
};

export default Signin;